import {
  convertLoadedHeader,
  convertSaveHeader,
  generateUpdatedImagePengecekanMobil,
} from "../../utils/editorHelpers";

const useEditorHeaderApi = ({
  requestGet,
  requestGetOne,
  requestPost,
  uiContext,
  navigate,
  location,
  currentUrl,
  isBerangkat,
  headerData,
  setHeaderData,
  setHeaderError,
  setSavedHeader,
  setListProblemData,
  setPengecekanPertama,
  setPengecekanSaved,
  setPengecekanBerangkatData,
  setPengecekanKembaliData,
  setPengecekanBerangkatDetilData,
  setPengecekanKembaliDetilData,
  getTrailerProblemFilter,
  saveHeaderDeleteKeys
}) => {
  // puts the pengecekan (and its detil rows) of both sides of a loaded header into state
  // copyNoteFromBerangkat: a kembali row without a note takes the note of the berangkat row with the same option
  const applyPengecekanFromHeader = (data, { copyNoteFromBerangkat } = {}) => {
    if (data.data_pengecekan_berangkat) {
      setPengecekanBerangkatData(data.data_pengecekan_berangkat);
      if (data.data_pengecekan_berangkat.data_pengecekan_mobil_detils) {
        setPengecekanBerangkatDetilData(
          generateUpdatedImagePengecekanMobil(
            data.data_pengecekan_berangkat.data_pengecekan_mobil_detils
          )
        );
      }
    }
    if (data.data_pengecekan_pulang) {
      setPengecekanKembaliData(data.data_pengecekan_pulang);
      if (data.data_pengecekan_pulang.data_pengecekan_mobil_detils) {
        if (copyNoteFromBerangkat) {
          for (const detilBerangkat of data.data_pengecekan_berangkat
            .data_pengecekan_mobil_detils) {
            for (const detilPulang of data.data_pengecekan_pulang
              .data_pengecekan_mobil_detils) {
              if (
                detilBerangkat.pengecekan_mobil_option_id ===
                detilPulang.pengecekan_mobil_option_id
              ) {
                if (!detilPulang.note || detilPulang.note === "") {
                  detilPulang.note = detilBerangkat.note;
                }
              }
            }
          }
        }
        setPengecekanKembaliDetilData(
          generateUpdatedImagePengecekanMobil(
            data.data_pengecekan_pulang.data_pengecekan_mobil_detils
          )
        );
      }
    }
  };

  // API call
  const saveHeader = async () => {
    setHeaderError({});
    const filledHeader = fillEmptyPeople(headerData);
    const valid = validateHeader(filledHeader);

    if (valid) {
      const body = convertSaveHeader(filledHeader, saveHeaderDeleteKeys);

      await requestPost({
        fullUrl: "/api/pemakaian/pemakaianmobil/save",
        body,
        isForm: false,
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
        onSuccess: ({ data, message }) => {
          setPengecekanPertama(false);
          fetchProblemMobil({ kendaraanId: data.kendaraan_id });
          uiContext.showSuccessMsg("Success", message);

          // reload front end data
          const loadedHeader = convertLoadedHeader(data);
          setHeaderData(loadedHeader);
          setSavedHeader(loadedHeader);
          applyPengecekanFromHeader(data);

          // navigate to new url
          const isNew = currentUrl.includes("new");
          if (data.id && data.id > 0 && isNew) {
            const urlParams = new URLSearchParams(location.search);
            const key = urlParams.get("key");
            if (key) {
              navigate(`../${data.id}?key=${encodeURIComponent(key)}`);
            } else {
              navigate("../" + data.id);
            }
            fetchHeader(data.id);
          }
        },
      });
    }
  };

  const fetchProblemMobil = async ({ kendaraanId }) => {
    if (kendaraanId && kendaraanId > 0) {
      const _kendaraanId = kendaraanId ?? headerData.data_kendaraan.id;
      var filter = `tanggal_selesai:=:Null;kendaraan_id:=:${_kendaraanId}`;

      filter += getTrailerProblemFilter(headerData);

      return requestGet({
        fullUrl: `/api/problem/problemkendaraan/data`,
        params: {
          page: 1,
          take: 1000,
          filter,
          order: "tanggal",
          order_method: "ASC",
        },
        onSuccess: ({ pagination, message, data }) => {
          setListProblemData(data);
        },
        onError: ({ message, data }) =>
          uiContext.showErrorMsg("Error", message),
      });
    }
  };

  const fetchHeader = async (id) => {
    if (id && id > 0) {
      await requestGetOne({
        fullUrl: `/api/pemakaian/pemakaianmobil/one/${id}`,
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
        onSuccess: ({ data, message }) => {
          fetchProblemMobil({ kendaraanId: data.kendaraan_id });

          if (!data.tanggal_transaksi) {
            data.tanggal_transaksi = new Date();
            setPengecekanPertama(true);
          }

          // reload front end data
          const loadedHeader = convertLoadedHeader(data);
          setHeaderData(loadedHeader);
          setSavedHeader(loadedHeader);
          applyPengecekanFromHeader(data, { copyNoteFromBerangkat: true });

          let pengecekanDetils = null;
          if (isBerangkat) {
            pengecekanDetils = data.data_pengecekan_berangkat
              ? data.data_pengecekan_berangkat.data_pengecekan_mobil_detils
              : null;
          } else {
            pengecekanDetils = data.data_pengecekan_pulang
              ? data.data_pengecekan_pulang.data_pengecekan_mobil_detils
              : null;
          }
          if (pengecekanDetils) {
            const mapChecked = {};
            for (const detil of pengecekanDetils) {
              const labelGroup = detil.label_grup;
              mapChecked[labelGroup] =
                (mapChecked[labelGroup] ?? 0) + detil.cek;
            }

            const saved = {
              bagian_depan: false,
              bagian_samping: false,
              bagian_belakang: false,
              bagian_dalam: false,
            };
            // every group of the checklist (also "trailer")
            Object.keys(mapChecked).forEach((labelGroup) => {
              saved[labelGroup] = mapChecked[labelGroup] > 0;
            });
            setPengecekanSaved(saved);
          }
        },
      });
    }
  };

  // supir berangkat and supir pulang copy each other when one of them is empty, then an empty pemakai takes
  // the supir berangkat (which is the supir pulang when there was no supir berangkat).
  // Nothing is ever copied from the pemakai.
  const fillEmptyPeople = (data) => {
    const isFilled = (field) => data[field] && data[field].id > 0;

    const filled = { ...data };
    const copy = (fromField, toField, toIdField) => {
      filled[toField] = data[fromField];
      filled[toIdField] = data[fromField].id;
    };

    if (isFilled("data_supir") && !isFilled("data_supir_pulang")) {
      copy("data_supir", "data_supir_pulang", "supir_pulang_id");
    } else if (!isFilled("data_supir") && isFilled("data_supir_pulang")) {
      copy("data_supir_pulang", "data_supir", "supir_id");
    }

    if (!isFilled("data_pemakai") && filled.data_supir) {
      filled.data_pemakai = filled.data_supir;
      filled.pemakai_id = filled.data_supir.id;
    }

    return filled;
  };

  const validateHeader = (data) => {
    let valid = true;
    const newError = {};
    const {
      data_supir,
      data_kendaraan,
      data_tujuan,
      speedo_mulai,
      speedo_akhir,
    } = data;

    // both supir are filled by fillEmptyPeople when one of them has data, so none means both are empty
    if (!data_supir || data_supir.id <= 0) {
      newError["data_supir"] = "Supir harus diisi";
      newError["data_supir_pulang"] = "Supir harus diisi";
      valid = false;
    }

    if (!data_kendaraan || data_kendaraan.id <= 0) {
      newError["data_kendaraan"] = "Kendaraan harus diisi";
      valid = false;
    }

    if (!data_tujuan || data_tujuan.id <= 0) {
      newError["data_tujuan"] = "Tujuan harus diisi";
      valid = false;
    }

    // the speedometer of the page being saved is mandatory
    if (isBerangkat) {
      if (!speedo_mulai || speedo_mulai <= 0) {
        newError["speedo_mulai"] = "Speedometer berangkat harus > 0";
        valid = false;
      }
    } else if (!speedo_akhir || speedo_akhir <= 0) {
      newError["speedo_akhir"] = "Speedometer kembali harus > 0";
      valid = false;
    }

    if (!valid) {
      setHeaderError(newError);
      uiContext.showErrorMsg("Error", Object.values(newError)[0]);
    }

    return valid;
  };

  return {
    saveHeader,
    fetchProblemMobil,
    fetchHeader
  };
};

export default useEditorHeaderApi;
